module.exports = __webpack_public_path__ + "img/index02.97c87842.png";